import {AppModule} from './app/app.module';
import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular-ivy';
import {Dedupe, ReportingObserver, ExtraErrorData, CaptureConsole, Debug, Offline} from '@sentry/integrations';
import {BrowserTracing} from '@sentry/browser';
import SentryRRWeb from "@sentry/rrweb";

import {SentryBreadcrumbCategory} from "./enum/sentry-breadcrumb-category";

const sentryBeforeSend = (event: Sentry.Event) => {
  let isNonErrorException = false;

  if (!event.exception) return null;
  if (!event.extra) return null;
  if (!event.extra.__serialized__) return null;

  if (event.exception.values && event.exception.values.length > 0 && event.exception.values[0].value) {
    isNonErrorException = event.exception.values[0].value.startsWith('Non-Error exception captured');

    if (isNonErrorException) {
      const {error, message} = event.extra.__serialized__ as any;

      let realErrMsg = error ? error.message : null;
      realErrMsg = realErrMsg || message;
      event.exception.values[0].value = realErrMsg;
      event.message = realErrMsg;
    }
  }

  return event;
};


if (environment.production) {
  Sentry.init({
    dsn: environment.sentry.dns,
    integrations: [
      new Dedupe(),
      new ExtraErrorData(),
      // new SentryRRWeb({
      //   checkoutEveryNth: 100,
      //   checkoutEveryNms: 15 * 60 * 1000,
      //   maskAllInputs: false
      // }),
      new BrowserTracing({
        tracingOrigins: ['*'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      new Sentry.Integrations.Breadcrumbs({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
      }),
    ],
    tracesSampleRate: 0.2,
    attachStacktrace: true,
    autoSessionTracking: true,
    maxBreadcrumbs: 100,
    debug: true,
    release: 'ocl.web.portal@1.3.0',
    environment: !environment.production ? 'production' : 'testing',
  });
  enableProdMode();
  Sentry.setTag("rrweb.active", "yes");
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('ngsw-worker.js')
        .then(() => {
          Sentry.addBreadcrumb({
            category: SentryBreadcrumbCategory.config,
            message: 'Service worker registered.',
            level: 'info',
          });
        })
        .catch((error: Error) => {
          Sentry.addBreadcrumb({
            category: SentryBreadcrumbCategory.config,
            message: 'There was an error registering the service worker.',
            level: 'error',
          });
          Sentry.captureException(error);
        });
    }
  })
  .catch(error => {
    Sentry.addBreadcrumb({
      category: SentryBreadcrumbCategory.config,
      message: 'There was an error mounting the application.',
      level: 'error',
    });
    Sentry.captureException(error);
  });
